import type { FileTypeEnum } from 'utils'

import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { t } from 'services/Translation'

import { ACCEPT_MAP_FILES_EXTENSIONS } from './constants'

export const getExtFile = (file: File) => file.name.split('.').pop()?.toLowerCase() || ''

export const validateFileExtension = (file: File, allowedExtensions: string[]): boolean =>
  allowedExtensions.includes(getExtFile(file))

const getErrorFilesExtensions = (errorFiles: File[]) =>
  errorFiles.reduce<string>((acc, item) => `${acc}, ${getExtFile(item)}`, '')

export const getAllowedExtByFiles = (files: File[], fileTypes: FileTypeEnum[] = []) => {
  const allowedExtensions = fileTypes.length
    ? fileTypes.reduce<string[]>((acc, item) => {
        if (item in ACCEPT_MAP_FILES_EXTENSIONS) {
          return [...acc, ...ACCEPT_MAP_FILES_EXTENSIONS[item]]
        }

        return acc
      }, [])
    : Object.values(ACCEPT_MAP_FILES_EXTENSIONS).flat()

  const validFiles: File[] = []
  const errorFiles: File[] = []

  files.forEach((file) => {
    if (validateFileExtension(file, allowedExtensions)) {
      validFiles.push(file)
    } else {
      errorFiles.push(file)
    }
  })

  return { validFiles, errorFiles, errorsExt: getErrorFilesExtensions(errorFiles) }
}

export const validateOrAddFiles = ({
  files,
  addFiles,
  contentType = [],
}: {
  files: File[]
  addFiles: (files: File[]) => void
  contentType?: FileTypeEnum[]
}) => {
  if (!contentType.length) {
    addFiles(files)
    return
  }

  const { errorFiles, validFiles, errorsExt } = getAllowedExtByFiles(files, contentType)
  if (errorFiles.length) {
    notify({
      type: NotificationType.warning,
      message: t('notify.file.uploadFileError', {
        count: errorFiles.length,
        extensions: errorsExt,
      }),
    })
  }

  if (validFiles.length) {
    addFiles(validFiles)
  }
}
